var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getWindow } from './general';
import { ERROR_MESSAGE } from '../components/order-details/returns/Soris/CancelConfirmationDrawer';
import { getMilitaryExchange } from './returns/returns-helper';
/**
 * Function for updating page data in the global variable _T
 * @param digitalData - the digital data object we want to push to page data array
 * @returns undefined
 */
export var setAnalytics = function (digitalData) {
    var _ddo = digitalData.init();
    if (getWindow()) {
        window._T = window._T || {};
        if (typeof window._T.pageData === 'undefined') {
            window._T.pageData = [];
        }
        window._T.pageData.push(_ddo);
    }
};
/**
 * Function for updating an event array in the global variable digitalData
 * @param analyticsEvent - an event object we want to push to event array
 * @returns undefined
 */
export var pushEventInfo = function (analyticsEvent) {
    var _a, _b, _c;
    if (analyticsEvent && ((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.digitalData)) {
        try {
            window.digitalData.event = ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.digitalData.event) || [];
            (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.digitalData.event.push(analyticsEvent);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error('DDO : Error in pushing the event info!!!');
        }
    }
};
export var pushEventInfoWithFulfillment = function (analyticsEvent) {
    var _a, _b, _c;
    if (analyticsEvent && ((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.digitalData)) {
        try {
            window.digitalData.event = ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.digitalData.event) || [];
            (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.digitalData.event.push(analyticsEvent);
        }
        catch (err) {
            console.error('DDO : Error in pushing the event info with fulfillment type!!!');
        }
    }
};
var setEvent = function (eventCategory, eventInfo, payload) {
    pushEventInfo(__assign({ category: {
            primaryCategory: eventCategory,
        }, eventInfo: eventInfo }, payload));
};
export var setPageInfo = function (type, displayType, pageSection, message, code) {
    pushPageErrorInfo({
        type: type,
        displayType: displayType,
        pageSection: pageSection,
        message: message,
        code: code,
    });
};
export var pushPageErrorInfo = function (pageError) {
    var _a, _b, _c;
    if (pageError && ((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.digitalData)) {
        window.digitalData.page.error = ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.digitalData.page.error) || [];
        (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.digitalData.page.error.push(pageError);
        setAnalytics(window.digitalData);
    }
};
export var pushErrorEvent = function (pageSection, errCode, errMessage, displayType) {
    if (displayType === void 0) { displayType = 'inline'; }
    setEvent('error', {
        eventName: 'post page error',
        error: [
            {
                type: 'error',
                displayType: displayType,
                pageSection: pageSection,
                code: errCode,
                message: errMessage,
            },
        ],
    });
};
export var setStashEvent = function (eventCategory, eventInfo, eventMode, payload) {
    pushEventInfo(__assign({ category: {
            primaryCategory: eventCategory,
        }, eventInfo: eventInfo, eventMode: eventMode }, payload));
};
export var stashLinkEvent = function (action) {
    setStashEvent('stash', {
        eventName: 'my account settings',
    }, 'stash', {
        stash: { myAccount: { settings: action } },
    });
};
export var setOverlayEvent = function (eventName, payload) {
    setEvent('overlay', {
        eventName: eventName,
    }, payload);
};
export var createPostOrderItems = function (cancellationItems) {
    return cancellationItems === null || cancellationItems === void 0 ? void 0 : cancellationItems.map(function (cancellationItem) {
        var _a, _b, _c;
        return {
            fulfillment: {
                method: cancellationItem.fulfillmentType === 'MA'
                    ? 'appl'
                    : cancellationItem.fulfillmentType.toLowerCase(),
                store: cancellationItem.fulfillmentType === 'BOPIS' ||
                    cancellationItem.fulfillmentType === 'BOSS'
                    ? cancellationItem.storeNumber
                    : undefined,
                zip: cancellationItem.fulfillmentType === 'MA' ||
                    cancellationItem.fulfillmentType === 'BODFS'
                    ? cancellationItem.zipCode
                    : undefined,
            },
            price: {
                basePrice: (((_a = cancellationItem.canceledQuantity) !== null && _a !== void 0 ? _a : 0) *
                    ((_b = cancellationItem === null || cancellationItem === void 0 ? void 0 : cancellationItem.unitPrice) !== null && _b !== void 0 ? _b : 0)).toFixed(2),
            },
            productInfo: {
                productName: cancellationItem.description,
                sku: cancellationItem.skuNumber,
                superSku: cancellationItem.superSku,
            },
            quantity: (_c = cancellationItem.canceledQuantity) === null || _c === void 0 ? void 0 : _c.toString(),
        };
    });
};
/**
 * Function for updating the postOrder object in the global variable digitalData
 * @param postOrderItems - a postOrderItems array we want to set in the postOrder object in the digitalData
 * @param transactionID - a string we want to set in the postOrder object in the digitalData
 * @returns undefined
 */
export var setPostOrderInfo = function (postOrderItems, transactionID, orderStatus) {
    var _a, _b, _c;
    if ((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.digitalData) {
        try {
            window.digitalData.postOrder = ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.digitalData.postOrder) || {};
            window.digitalData.postOrder.transactionID = transactionID;
            window.digitalData.postOrder.item = postOrderItems;
            if (orderStatus) {
                window.digitalData.postOrder.orderStatus = orderStatus;
            }
            setAnalytics((_c = getWindow()) === null || _c === void 0 ? void 0 : _c.digitalData);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error('DDO : Error in setting the post order object and intializing it!!!');
        }
    }
};
/**
 * Function for setting page details and transactionID (in postOrder object) in the global variable digitalData
 * @param page - a page details object we want to set in the digitalData
 * @param transactionID - a string we want to set in the postOrder object in the digitalData
 * @returns undefined
 */
export var setOrderDetaillsPageInfo = function (page, transactionID, category) {
    var _a, _b, _c;
    if ((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.digitalData) {
        try {
            window.digitalData.page = page;
            window.digitalData.postOrder = ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.digitalData.postOrder) || {};
            window.digitalData.postOrder.transactionID = transactionID;
            window.digitalData.category = category;
            setAnalytics((_c = getWindow()) === null || _c === void 0 ? void 0 : _c.digitalData);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error('DDO : Error in setting the page and post order object and intializing it!!!');
        }
    }
};
/**
 * Function for setting page details in the global variable digitalData
 * @param page - an page details object we want to set in the digitalData
 * @returns undefined
 */
export function setPageDetails(page) {
    var _a, _b;
    if ((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.digitalData) {
        try {
            window.digitalData.page = page;
            setAnalytics((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.digitalData);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error('DDO : Error in setting the page object and initializing it!!!');
        }
    }
}
export var setTrackBusinessSpendPageInfo = function (page, transactionID, category) {
    var _a, _b, _c;
    if ((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.digitalData) {
        try {
            window.digitalData.page = page;
            window.digitalData.postOrder = ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.digitalData.postOrder) || {};
            window.digitalData.postOrder.transactionID = transactionID;
            window.digitalData.category = category;
            setAnalytics((_c = getWindow()) === null || _c === void 0 ? void 0 : _c.digitalData);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error('DDO : Error in setting the page and post order object and intializing it!!!');
        }
    }
};
export var setPageDetailsValues = function (primaryCategory, subCategory1, subCategory2, pageName, pageType) {
    var page = {
        category: {
            primaryCategory: primaryCategory,
            subCategory1: subCategory1,
            subCategory2: subCategory2,
        },
        pageInfo: {
            pageName: pageName,
            pageType: pageType,
        },
    };
    setPageDetails(page);
};
export var setPageInfoWithEventCategories = function (primaryCategory, subCategory1, subCategory2, pageName, pageType) {
    var page = {
        category: {
            primaryCategory: primaryCategory,
            subCategory1: subCategory1,
            subCategory2: subCategory2,
        },
        pageInfo: {
            pageName: pageName,
            pageType: pageType,
        },
    };
    setPageDetails(page);
};
export var setPageInfoWithEvent = function (primaryCategory, subCategory1, subCategory2, pageName, pageType, pageLoadEvent) {
    var page = {
        category: {
            primaryCategory: primaryCategory,
            subCategory1: subCategory1,
            subCategory2: subCategory2,
        },
        pageInfo: {
            pageName: pageName,
            pageType: pageType,
            pageLoadEvent: pageLoadEvent,
        },
    };
    setPageDetails(page);
};
/**
 * Map payment method display/value or tender type to analytics account type code.
 */
export var getAnalyticsAccountType = function (paymentMethod) {
    if (paymentMethod === void 0) { paymentMethod = ''; }
    var normalized = (paymentMethod || '').toUpperCase();
    var cardMap = {
        VISA: 'visa',
        VI: 'visa',
        MC: 'mc',
        AMEX: 'amex',
        DISC: 'disc',
        HDCON: 'hdcon',
        HDCOM: 'hdcom',
        PTC: 'protrade',
    };
    return cardMap[normalized];
};
// Tagging for when the user clicks on Start a Return Button
export var TagStartAReturn = function (orderDetailsData) {
    var _a, _b;
    var exchange = getMilitaryExchange(orderDetailsData);
    // Determine account type: use isPTCOrder flag first, then tenders
    var accountType = orderDetailsData.isPTCOrder
        ? 'protrade'
        : getAnalyticsAccountType((_b = (_a = orderDetailsData.tenders) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.type);
    var tagObject = {
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'start a return' },
        exchange: exchange,
        myAccount: {
            settings: "purchase history: order details: ".concat(accountType),
        },
    };
    pushEventInfo(tagObject);
};
// Analytics used to capture when user clicks on the cancel return button regardless if it was successful or not
export var TriggerCancelSorisOnClickCancelAnalytics = function () {
    return pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'my account settings' },
        myAccount: {
            settings: 'purchase history: order details: cancel this return overlay: yes cancel this return button',
        },
    });
};
// Analytics used to capture when user leaves the cancel return drawer without cancelling the return
export var TriggerCancelSorisOnAbandonAnalytics = function () {
    return pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'my account settings' },
        myAccount: {
            settings: 'purchase history: order details: cancel this return overlay: no button or x button',
        },
    });
};
// Analytics used to capture when a soris cancel attempt was not successful
export var TriggerCancelSorisOnErrorAnalytics = function () {
    return pushEventInfo({
        category: { primaryCategory: 'error' },
        eventInfo: {
            eventName: 'post page error',
            error: [
                {
                    type: 'system',
                    displayType: 'inline',
                    pageSection: 'post page error',
                    message: ERROR_MESSAGE,
                    code: 'n/a',
                },
            ],
        },
    });
};
export var TriggerViewQRCodeAnalytics = function () {
    return pushEventInfo({
        category: {
            primaryCategory: 'overlay',
        },
        eventInfo: {
            eventName: 'order details: in store return qr code',
        },
    });
};
/**
 *****************************************************
 *  PRINT RETURN LABEL TAGGING
 *****************************************************
 */
/**
 * Tagging for when the user clicks the print return label button
 */
export var TagShippingLabelButtonSubmission = function () {
    var tagObject = {
        category: {
            primaryCategory: 'button submission',
        },
        eventInfo: {
            eventName: 'my account settings',
        },
        myAccount: {
            settings: 'purchase history: order details: print free return label button',
        },
    };
    pushEventInfo(tagObject);
};
/**
 *****************************************************
 *  UPS BARCODE TAGGING
 *****************************************************
 */
/**
 * Tagging for when the user clicks the print return label button
 */
export var TagUPSBarcode = function (isOrderDetails) {
    var tagObject = {
        category: {
            primaryCategory: 'button submission',
        },
        eventInfo: {
            eventName: 'my account settings',
        },
        myAccount: {
            settings: isOrderDetails
                ? 'purchase history: order details: view ups barcode button'
                : 'purchase history: view ups barcode button',
        },
    };
    pushEventInfo(tagObject);
};
